/**
 * PermissionRow Component
 * Displays a single permission row with checkboxes for each role
 */

import React from 'react';

const PermissionRow = ({ 
  permission, 
  roles, 
  isRoleLocked, 
  hasPermission, 
  permissionChanges, 
  formatAction, 
  formatRoleName,
  togglePermission, 
  hoveredCell, 
  setHoveredCell 
}) => {
  return (
    <tr className="permission-row">
      {/* Permission name column */}
      <td className="permission-name">
        <span className="permission-dot"></span>
        {formatAction(permission.action)}
      </td>
      
      {/* Checkbox column for each role */}
      {roles.map(role => {
        const isLocked = isRoleLocked(role);
        const isChecked = hasPermission(role.id, permission.id);
        const changeKey = `${role.id}-${permission.id}`;
        const hasChange = changeKey in permissionChanges;
        const cellKey = `${role.id}-${permission.id}`;
        
        return (
          <td 
            key={role.id} 
            className={`permission-cell ${isLocked ? 'locked' : ''}`}
            onMouseEnter={() => isLocked && setHoveredCell(cellKey)}
            onMouseLeave={() => setHoveredCell(null)}
          >
            <label className="permission-checkbox-wrapper">
              <input
                type="checkbox"
                checked={isChecked}
                disabled={isLocked}
                onChange={() => togglePermission(role.id, permission.id)}
                className={isLocked ? 'locked' : ''}
              />
              <span className={`checkbox-custom ${isLocked ? 'locked' : ''} ${isChecked ? 'checked' : ''}`}>
                {isChecked && <i className="bi bi-check"></i>}
              </span>
            </label>
            
            {/* Tooltip for locked checkboxes */}
            {isLocked && hoveredCell === cellKey && (
              <div className="permission-tooltip">
                {formatRoleName(role.name)} permissions are locked
              </div>
            )}
          </td>
        );
      })}
    </tr>
  );
};

export default PermissionRow;

